module.exports = __webpack_public_path__ + "img/banner.8b35530c.png";